import client from '@/api/client';
import { gql } from '@apollo/client';
import exerciseFragments from '@/gql-fragments/exercise';
import lessonFragments from '@/gql-fragments/lesson';
import trainingFragments from '@/gql-fragments/training-element';

const classStart = (
  params: {
    courseId: string;
    lessonId: string;
    exerciseId: string;
    sessionId: string;
  },
) => client.query({
  query: gql`
    query($courseId: Int, $lessonId: Int, $exerciseId: Int, $sessionId: String) {
      getLessons(courseId: $courseId, sessionId: $sessionId) {
        ...Lesson
      }
      getExercises(lessonId: $lessonId, sessionId: $sessionId) {
        ...Exercise
      }
      getTrainingElements(exerciseId: $exerciseId, sessionId: $sessionId) {
        ...TrainingElement
      }
    }
    ${lessonFragments.Lesson}
    ${exerciseFragments.Exercise}
    ${trainingFragments.TrainingElement}
  `,
  variables: {
    courseId: parseInt(params.courseId, 10),
    lessonId: parseInt(params.lessonId, 10),
    exerciseId: parseInt(params.exerciseId, 10),
    sessionId: params.sessionId,
  },
});

const classChange = (
  params: {
    lessonId: string;
    exerciseId: string;
    sessionId: string;
  },
) => client.query({
  query: gql`
    query($lessonId: Int, $exerciseId: Int, $sessionId: String) {
      getExercises(lessonId: $lessonId, sessionId: $sessionId) {
        ...Exercise
      }
      getTrainingElements(exerciseId: $exerciseId, sessionId: $sessionId) {
        ...TrainingElement
      }
    }
    ${exerciseFragments.Exercise}
    ${trainingFragments.TrainingElement}
  `,
  variables: {
    lessonId: parseInt(params.lessonId, 10),
    exerciseId: parseInt(params.exerciseId, 10),
    sessionId: params.sessionId,
  },
});

export {
  classStart,
  classChange,
};
